export const redirectOutlookUrl = `${window.location.origin}/outlook-integration`;
export const redirectGraphUrl = `${window.location.origin}/graph-integration`;
export const redirectGmailUrl = `${window.location.origin}/account-setting-gmail`;
export const redirectHubspotUrl = `${window.location.origin}/account-setting-hubspot`;
export const redirectUrlXero = window.location.origin + '/xero-sync';
export const redirectUrl = 'https://app.ezymigrate.com/document-sync';
export const messageConfig = { top: 50, duration: 1 };
export const forgotPasswordUrl = `${window.location.origin}/forgot-password/`;

// New UI (Next.js app) that login hands the session over to — see
// src/Common/newUiRedirect.js.
//
// Per-environment and swapped per branch, the same way baseURL.js carries the
// API host, because nothing in the pipeline supplies it: azure-pipelines.yaml
// runs a bare `npm run build` and sets no REACT_APP_* variables, so whatever is
// written here is what ships.
//
// This branch deploys to PRODUCTION, where baseURL points at beta-api, so the
// session must go to the production New UI — the value HeaderBar used to
// hardcode for its "New Version" toggle, now shared with the login hand-off so
// the two cannot open different New UIs. Handing production tokens to a QA or
// UAT New UI would post them to an app on a different backend, and be refused
// anyway — the New UI only accepts the origins on its own allow-list.
//
//   UAT:              https://uatnewui.ezymigrate.co.nz
//   DeploytoVM1 / QA: https://qanewui.ezymigrate.co.nz
//
// REACT_APP_NEW_UI_URL still wins when a build points elsewhere (a locally-run
// `next dev`).
export const newUiUrl =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_NEW_UI_URL) ||
  'https://ai.ezymigrate.com';
